export default [
  {
    title: 'VMware Inc.',
    subtitle: 'Member of Technical Staff II',
    date: 'July 2019 - Present',
    paragraphs: [
      'Working on React + Typescript to create multiple applications for vRealize Suite Lifecycle Manager.',
      'Working with Spring Boot to write RESTful API Endpoints using JPA. PostgreSQL was used as the underlying database.',
      'Working on Java based Plugins having state-machines to perform the vRealize Suite Lifecycle Manager Tasks.',
      'Created a Python based Interactive CLI using Click to improve the productivity of the Dev Team.',
      'Worked on JUnits using PowerMock to increase the coverage.',
      'Authored a Dynamic Gating based framework for dynamic role based access',
      'Submitted Multiple VMware RADIO(Research and Development Innovation Offsite) ideas.'
    ]
  },
  {
    title: 'VMware Inc.',
    subtitle: 'Member of Technical Staff I',
    date: 'July 2018 - June 2019',
    paragraphs: [
      'Authored React component Library based on the VMware Clarity Design(v2) System using Typescript.',
      'Worked on Refactoring the vRealize Suite Lifecycle Manager UI from Angular to React using the Clarity React Component Library.',
      'Worked on StencilJS based Shell App to embed various Web Apps in vRealize Lifecycle Manager UI.',
      'Worked on NGINX for reverse proxy.',
      'Mentored New College Graduates during the NCG Bootcamp 2019 for a period of 1 month.',
      'Worked on Plugin Service based on Spring Boot.',
      'Created MLaaS Application during my NCG Bootcamp (2018) which was similar to Azure ML Studio making use of state machines.'
    ]
  },
  {
    title: 'VMware Inc.',
    subtitle: 'Intern',
    date: 'January 2018 - June 2018',
    paragraphs: [
      'Created a Plugin for VMware Horizon for vRealize Suite Lifecycle Manager and wrote Java based state machines to perform all the supported operations.',
      'Worked on vRealize Suite Lifecycle Manager UI based on Angular.',
      'Created Spring Boot Services for performing GIT Operations using JGit Library based on Java.',
      'Worked on Angular based Dynamic UI which was rendered based on spec coming from API. Created these dynamic components based on VMware Clarity Design.',
      'Worked on Dynamic Layouting Directive in Angular.',
      'Did a POC on deployment Deployment Management and Orchestration tools like Ansible, Puppet and Chef.',
      'Wrote Java based state machines tasks to automate the various workflows of Ansible, Puppet and Chef.'
    ]
  },
  {
    title: 'Chawtech Solutions',
    subtitle: 'Summer Intern',
    date: 'May 2017 - August 2017',
    paragraphs: [
      'Worked on Android apps during the tenure of internship learning basic as well as advanced concepts of Android',
      'Created Rydo Rider and Driver App which was an application to book a cab. Worked on integration with RESTful APIs using Volley. Also implemented Google services for real-time taxi booking and map updates.',
      'Created Hajati, An E-Commerce Application for women based in UAE to buy clothing and accessories.',
      'Also worked on apps like ATNInfo and few other applications which are already present in PlayStore.'
    ]
  },
  {
    title: "L'Oréal India Pvt. Ltd.",
    subtitle: 'Team Lead (College Project)',
    date: 'October 2015 - December 2015',
    paragraphs: [
      'Created a productivity management web application based using AngularJS for front-end and Slim Framework in PHP for creating REST APIs.',
      'Used MySQL DB to store data.',
      'Used ChartJS to represent the data graphically for easy analysis.',
      "Sold the Project to the L'Oréal Factory."
    ]
  }
];
